<template>
    <div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
        <div class="add_tits" ref="title">
            <el-form class="form-inlines" :inline="true">
                <el-form-item label="日期:">
                    <el-date-picker v-model="formData.time" size="small" value-format="yyyy-MM" type="month"
                        placeholder="选择月">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="专家:">
                    <el-select v-model="formData.docname" placeholder="请选择" size="small" filterable clearable>
                        <el-option v-for="item in  formData.doc_options" :key="item.id" :label="item.nickname"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" size="small" @click="begin">搜索</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="ibox-content">
            <el-table :data="tableData" border v-loading="loading" :height="heights" ref="configurationTable">
                <el-table-column prop="doc_name" label="专家" show-overflow-tooltip> </el-table-column>
                <el-table-column prop="all_count" label="用户报到总数" show-overflow-tooltip> </el-table-column>
                <el-table-column prop="month_count" label="月份新增用户数" show-overflow-tooltip> </el-table-column>
                <el-table-column prop="patient_birthday" label="已发奖金" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>
                            <el-button type="text" v-if="scope.row.bdCapitalDetails" size="small" @click="openyfjj(scope.row)">详情</el-button>
                            <el-button type="text" v-else size="small" disabled>未发</el-button>
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="patient_birthday" label="奖励金额录入" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>
                            <el-button type="success" size="small" @click="jj_input(scope.row)">录入</el-button>
                        </span>
                    </template>
                </el-table-column>
            </el-table>
            <div class="u-f u-ac u-jsb ft_mr">
                <div></div>
                <div>
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="currentPage" :page-sizes="[15, 30, 50, 100]" :page-size="pagesize"
                        layout="total, sizes, prev, pager, next, jumper" :total="count">
                    </el-pagination>
                </div>
            </div>

        </div>
        <!-- 录入奖励 -->
        <el-dialog title="录入奖励" :visible.sync="dialogVisible" center top="150px" width="30%" class="dialogs">
            <el-divider></el-divider>
            <div class="dialog-ibox-content">
                <el-form class="form-inlines" label-width="150px">
                    <el-form-item label="日期:">
                        <span>{{monthdata.month}}</span>
                    </el-form-item>
                    <el-form-item label="专家:">
                        <span>{{monthdata.doc_name}}</span>
                    </el-form-item>
                    <el-form-item label="用户报到总数:">
                        <span>{{monthdata.all_count}}</span>
                    </el-form-item>
                    <el-form-item label="月份新增用户:">
                        <span>{{monthdata.month_count}}</span>
                    </el-form-item>
                    <el-form-item label="已发奖金:">
                        <span>{{monthdata.bdCapitalDetails?monthdata.bdCapitalDetails.price:0}}</span>
                    </el-form-item>
                    <el-form-item label="奖励金额:">
                        <el-input v-model="jlje_value" size="small" type="number" min="0" style="width:200px"
                            placeholder="请输入金额"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false" size="small">取消</el-button>
                <el-button @click="sub_input" type="primary" :loading='subloading' size="small">确定</el-button>
            </span>
        </el-dialog>
         <!-- 已发奖励 -->
        <el-dialog title="已发奖励" :visible.sync="yfjjdialogVisible" center top="150px" width="30%" class="dialogs">
            <el-divider></el-divider>
            <div class="dialog-ibox-content">
                <el-form class="form-inlines" label-width="150px">
                    <el-form-item label="日期:">
                        <span>{{monthmon.create_time}}</span>
                    </el-form-item>
                    <el-form-item label="类型:">
                        <span>{{monthmon.source_text}}</span>
                    </el-form-item>
                    <el-form-item label="金额:">
                        <span>{{monthmon.price}}</span>
                    </el-form-item>
                </el-form>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button @click="yfjjdialogVisible = false" size="small">确定</el-button>
            </span>
        </el-dialog>

    </div>
</template>


<script>
    import {
        mapState
    } from 'vuex'
    export default {
        data() {
            return {
                formData: {
                    time: '',
                    docname: '',
                    doc_options: [],
                },
                loading: false,
                subloading:false,
                tableData: [],
                currentPage: 1,
                pagesize: 15,
                count: 0,
                heights: null,
                dialogVisible: false,
                yfjjdialogVisible:false,
                jlje_value: 0,
                monthdata:{},
                monthmon:{},
            };
        },
        computed: {
            ...mapState({
                user: state => state.user.user,
            })
        },
        mounted() {
            let that = this
            that.getall()
            that.getHeight()
            that.getDate7()
        },
        methods: {
            // 获取高度
            getHeight() {
                let that = this;
                var title = that.$refs.title.offsetHeight
                that.heights = window.innerHeight - title - 170 + 'px'
                window.onresize = () => {
                    var title = that.$refs.title.offsetHeight
                    that.heights = window.innerHeight - title - 170 + 'px'
                }
            },
            begin() {
                let that = this
                that.currentPage = 1
                that.pagesize = 15
                that.search()
            },
            search() {
                let that = this
                that.loading = true
                axios
                    .post("/admin/DoctorQrcodeOrder/userBdMonthReport", {
                        page: that.currentPage,
                        page_count: that.pagesize,
                        month: this.formData.time,
                        doc_id: this.formData.docname,
                    }, {
                        token: true
                    })
                    .then(response => {
                        that.loading = false
                        that.tableData = response.data.data.list
                        that.count = response.data.data.total
                    })
                    .catch(error => {})
            },
            handleSizeChange(val) {
                let that = this
                that.pagesize = val;
                that.search()
            },
            handleCurrentChange(val) {
                let that = this
                that.currentPage = val;
                that.search()
            },
            getall() {
                this.getdoc()
            },
            getdoc() {
                axios
                    .post("/admin/doctorAssistantList", {}, {
                        token: true
                    })
                    .then(response => {
                        this.formData.doc_options = response.data.data
                    })
                    .catch(error => {})
            },
            //上月
            getDate7() {
                let that = this;
                let nowDate = new Date();
                nowDate.setDate(0);
                let befDate = new Date(nowDate.getTime());
                let byear = befDate.getFullYear();
                let bmonth = befDate.getMonth() + 1;
                let bday = befDate.getDate();
                bmonth = bmonth > 9 ? bmonth : '0' + bmonth
                bday = bday > 9 ? bday : '0' + bday
                let end = `${byear}-${bmonth}-${bday}`;
                let start = `${byear}-${bmonth}`
                this.formData.time = start
                that.begin()
            },
            jj_input(row) {
                this.dialogVisible = true
                this.monthdata=row
            },
            openyfjj(row){
                this.monthmon=row.bdCapitalDetails
                this.yfjjdialogVisible=true
            },
            sub_input() {
                if (!this.jlje_value) return this.$message.error('请输入奖励金额')
                if (this.jlje_value <= 0) return this.$message.error('奖励金额必须大于0')
                this.subloading=true
                axios
                    .post("/admin/DoctorQrcodeOrder/userBdMonthBonus", {
                        month: this.monthdata.month,
                        grantee_id: this.monthdata.doc_id,
                        price: this.jlje_value-0,
                    }, {
                        token: true
                    })
                    .then(res => {
                        if (res.data.code == 200) {
                            this.$message({
                                message: '成功！',
                                type: 'success'
                            });
                            this.dialogVisible=false
                            this.jlje_value=0
                            this.search()
                        }else{
                            this.$message.error(res.data.msg)
                        }
                       this.subloading=false
                    })
                    .catch(error => {
                         this.subloading=false
                    })
            },


        },

    };
</script>


<style>

</style>